import { render, staticRenderFns } from "./builder-customer-card.vue?vue&type=template&id=0628345a&scoped=true&"
import script from "./builder-customer-card.vue?vue&type=script&lang=js&"
export * from "./builder-customer-card.vue?vue&type=script&lang=js&"
import style0 from "./builder-customer-card.vue?vue&type=style&index=0&id=0628345a&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0628345a",
  null
  
)

export default component.exports